"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogger = void 0;
const loggerInstance_1 = require("../utils/logger/loggerInstance");
function useLogger(scope) {
    return {
        debug: (msg, context) => loggerInstance_1.logger.debug(scope ? `[${scope}] ${msg}` : msg, context),
        info: (msg, context) => loggerInstance_1.logger.info(scope ? `[${scope}] ${msg}` : msg, context),
        warn: (msg, context) => loggerInstance_1.logger.warn(scope ? `[${scope}] ${msg}` : msg, context),
        error: (msg, context) => loggerInstance_1.logger.error(scope ? `[${scope}] ${msg}` : msg, context),
    };
}
exports.useLogger = useLogger;
